import React, { useState } from 'react';
import classNames from 'classnames';
import Link from 'next/link';

import { INavChild } from '@/components/Nav/utilities';
import { Route } from 'next';

const NavPanel = ({
  topClass,
  link,
  active,
  onClose,
}: {
  topClass: string;
  link: INavChild;
  active: string;
  onClose: (href: Route) => void;
}) => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const toggleTab = (index: number) => {
    setActiveTab((prev) => (prev === index ? prev : index));
  };

  return (
    <div
      className={classNames(
        'fixed left-0 z-50 flex w-full transform border border-gray-200 bg-white transition-all duration-200',
        topClass,
        active !== link.name &&
          'pointer-events-none invisible opacity-0 delay-75'
      )}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="mx-auto max-w-view text-[#525252] md:flex">
        <aside className="flex w-[17.5rem] flex-col gap-4 border-r border-background-3 pb-4 pl-3 pr-0 pt-6">
          <ul className="border-b border-background-3 pb-4 md:flex-1">
            {link.items.map((category, index) => (
              <li
                key={category.name}
                className="border-b border-outline-stroke md:border-none"
              >
                <button
                  className={classNames([
                    `py w-full cursor-pointer px-5 py-[5px] text-left text-sm transition-colors hover:bg-background-3`,
                    activeTab === index &&
                      'bg-background-3 font-medium text-[#161616]',
                  ])}
                  onClick={() => toggleTab(index)}
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
          <Link
            href="/contact"
            className="self-start text-sm text-primary-default"
            onClick={() => onClose('/contact')}
          >
            Let’s Talk →
          </Link>
        </aside>
        <main className="hidden flex-1 md:flex">
          <div className="max-h-[calc(80vh-2rem)] overflow-y-auto px-4 pb-10 pt-6">
            <p className="pl-4 text-h5">{link.items[activeTab ?? 0].name}</p>
            <div className="mt-8 grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-2 lg:grid-cols-3">
              {link.items[activeTab ?? 0].items.map((item) => (
                <Link
                  href={item.href}
                  key={item.name}
                  className="w-full cursor-pointer p-4 text-left text-sm transition-colors hover:bg-background"
                  onClick={() => onClose(item.href)}
                >
                  <span className="font-semibold">{item.name}</span>
                  <span className="block text-sm text-secondary">
                    {item.description}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default NavPanel;
